import { FC, memo } from 'react';

export const OrderManagement: FC = memo(() => {
  return <></>;
});
